// TEMPORÁRIO — mock local do Portal do Credenciado, remover no desenvolvimento do backend.
/**
 * Fonte de dado mockada do Portal do Credenciado.
 *
 * DECISÃO REGISTRADA: só as telas cujo `dados.ts` importa este arquivo trazem
 * dado fictício de leitura — elas ainda não leem a API, porque o back-end delas
 * é a Fase 8 da OS nº 001. A exceção, com a lista dessas telas, está no
 * `CLAUDE.md` ("Proibido", decisão do dono de 2026-10-02). O resto do portal
 * já lê a API real e não passa por aqui: painel, Contratos e Termos, Ordens de
 * Serviço, veículos, monitores, inscrição, pré-credenciamento, situação
 * operacional e vencimentos. Fica registrado como dívida técnica: quando a API
 * de uma tela existir, cada `queryFn` que chama `resolverMock` troca para
 * `chamarApi(...)`, mantendo a mesma assinatura de hook — é a única mudança
 * que as telas vão precisar.
 *
 * O atraso simulado existe para a tela exercitar de verdade o estado de
 * carregando (regra de interface 3 do CLAUDE.md: toda tela tem os quatro
 * estados) — sem ele, o `isLoading` do React Query nunca apareceria.
 */
export function resolverMock<T>(dado: T, atrasoEmMs = 350): Promise<T> {
  return new Promise((resolve) => {
    setTimeout(() => resolve(dado), atrasoEmMs);
  });
}

/**
 * Data `aaaa-mm-dd` a `dias` de `hoje` (negativo é passado). Mock não guarda
 * data literal: data fixa envelhece sozinha e um dia mostra à SMT vencimento
 * de meses que já passaram.
 */
export function diaDaqui(dias: number, hoje: Date): string {
  const data = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() + dias);
  const mes = String(data.getMonth() + 1).padStart(2, '0');
  const dia = String(data.getDate()).padStart(2, '0');
  return `${data.getFullYear()}-${mes}-${dia}`;
}
